import { useNewChat } from 'src/layouts/SidebarV2/hooks';
import { sidebarIcons } from 'src/layouts/SidebarV2/icons';
import { IconAction } from 'src/layouts/SidebarV2/primitives';

export interface MobileHeaderProps {
  onOpenSidebar: () => void;
}

const MobileHeader = ({ onOpenSidebar }: MobileHeaderProps) => {
  const { startNewChat } = useNewChat();

  return (
    <header className="tw:flex tw:items-center tw:justify-between tw:w-full tw:p-m tw:border-b tw:border-solid tw:border-border-secondary tw:bg-primary">
      <IconAction
        icon={sidebarIcons.layoutLeft}
        label="Open sidebar"
        iconSize={20}
        colorClass="tw:text-icon-primary"
        onClick={onOpenSidebar}
      />
      <IconAction
        icon={sidebarIcons.newChat}
        label="New chat"
        iconSize={20}
        colorClass="tw:text-icon-primary"
        onClick={() => startNewChat()}
      />
    </header>
  );
};

export { MobileHeader };
